// 根据电脑来判断语言
module.exports = {
	toast: {
		comfirmBtn1: 'ส่ง',
		comfirmBtn3: 'สมัคร',
		comfirmBtn4: 'กลับ',
		comfirmBtn5: 'ยกเลิก',
		comfirmBtn2: 'ยืนยัน',
	},
	myCard: {
		loginfirst: 'กรุณาเข้าสู่ระบบก่อน',
		gotogame: 'เข้าสู่ระบบ',
		gamename: 'เว็บเติมเงินทางการ Cat Fantasy', //catfantasy-payment 貓之城-儲值中心 チャージセンター『キャットファンタジ―』 캣 판타지-상점
		titleAccount: 'ข้อมูลบัญชี',
		account: 'บัญชี',
		activeAccount: 'บัญชีปัจจุบัน',
		password: 'รหัสผ่าน',
		titlePayWay: 'วิธีชำระเงิน',
		titlePayAccount: 'แพ็กเกจ',
		titlePayList: 'ตารางราคาอิริธิสต์',
		myCardPoint: 'คะแนน MyCard',
		myCardGiftNum: 'อิริธิสต์ (ชิ้น)',
		submit: 'ส่ง',
		change: 'ทำการเติมเงิน',
		logout: 'ออกจากระบบ',
		gameRole: 'ตัวละคร',
		noGameRole: 'ไม่มีตัวละครที่ผูกไว้ กรุณาเปลี่ยนบัญชีและลองใหม่',
		point: 'คะแนน',
		cardNum: 'หมายเลขบัตร',
		cardPass: 'รหัสบัตร',
		placeholderCardNum: 'กรุณากรอกหมายเลขบัตร',
		placeholderCardPass: 'กรุณากรอกรหัสผ่าน',
		extraGift: 'โบนัสพิเศษ',
		time: 'นับถอยหลัง',
		timeout: 'หมดเวลา',
		payWay1: 'หักคะแนนกระเป๋าเงิน',
		payWay2: 'บัตรคะแนน',
		payWay3: 'หักคะแนนสมาชิก',
		payWay4: 'เติมเงินด้วยบัตร',
		secTitle1: 'โปรโมชั่นพิเศษ',
		secTitle2: 'คุ้มค่า',
		secTitle3: 'ส่วนลดพิเศษ',
		secTitle4: 'ร้านค้าถาวร',
		failed: 'การทำรายการล้มเหลว',
		tip: 'โปรดทราบ: การเติมเงินผ่านเว็บไซต์ไม่ได้รับโบนัสการเติมเงินครั้งแรกและโบนัสโอปอล',
		days: 'วัน',
		pay1: 'กรุณาชำระเงินโดยเร็ว',
		pay2: 'ชำระเงินแล้ว',
		pay3: 'ไม่พบผลการค้นหา',
		pay4: 'หากชำระเงินแล้ว กรุณาตรวจสอบในเกมภายหลัง',
		pay5: 'กรุณาตรวจสอบในเกมภายหลัง',
		loginFirst: 'กรุณาเข้าสู่ระบบก่อน',
		extraSend: 'โบนัส:',
		extraTitle: 'กำหนดจำนวนโอปอลเอง',
		stock: 'คงเหลือ:',
		otherNum: 'จำนวนอื่นๆ',
		chooseCoupon: 'โค้ดส่วนลด',
		loginTips: 'สามารถดูได้หลังเข้าสู่ระบบ',
		noCoupon: 'ไม่มีโค้ดที่ใช้ได้',
		expireAt: 'ใช้ได้ถึง:',
		disCount: 'ลด',
		useType: 'ใช้ได้เมื่อซื้อครบ {amount}',
		proInfo: 'ข้อมูล:',
		proNum: 'จำนวน:',
		roleInfo: 'ข้อมูลตัวละคร:',
		proPrice: 'ราคาเต็ม:',
		disCountPrice: 'ส่วนลด:',
		totalPrice: 'ยอดรวม:',
		inputNum: 'กรอกจำนวนเงินเติม',
		extraTips:
			'หมายเหตุ: จำนวนเงินเติมต้องมากกว่า 6,480 และเป็นจำนวนเท่าของ 10 ไม่เกิน 99,990 ต่อครั้ง',
		chooseRole: 'เลือกตัวละคร',
		maxNum: 'ส่วนลดสูงสุด',
		couponTips:
			'คุณมีคำสั่งซื้อที่ใช้คูปองและยังไม่ได้ชำระเงิน ต้องการยกเลิกคำสั่งซื้อและคืนคูปองหรือไม่?',
		couponTips2: '',
		useCoupon: 'คูปองที่ใช้:',
		originalAmount: 'ราคาเต็ม:',
		productSubject: 'ข้อมูลสินค้า:',
		payAmount: 'ยอดชำระ:',
		couponBtn1: 'ยกเลิกและคืนโค้ด',
		couponBtn2: 'ชำระเงินคำสั่งซื้อก่อนหน้า',
		closeMyCard: 'ปิดหน้านี้',
		empty: 'กรุณาเข้าสู่ระบบเพื่อดูแพ็กเกจ',
		coupon: 'โค้ด',
		check: 'ดู',
		orderTitle: 'ยืนยันคำสั่งซื้อ',
		checkCoupon: 'ดูโค้ด',
		orderCancel: 'ยกเลิกคำสั่งซื้อแล้ว',
		orderListTitle: 'ตรวจสอบประวัติการชำระเงินออนไลน์',
		orderListSecTitle: 'ดูประวัติย้อนหลังได้สูงสุด 1 ปี',
		orderListEmpty: 'ไม่มีประวัติการซื้อ',
		orderListPayWay: 'ชำระเงิน',
		orderListPayTime: 'เวลาชำระเงิน:',
		orderListCreateTime: 'เวลาสั่งซื้อ:',
		orderListNum: 'หมายเลขคำสั่งซื้อ:',
		orderListExtra: 'รวม VAT',
		orderListCloseTime: 'เวลาที่เหลือก่อนยกเลิกคำสั่งซื้อ:',
		orderListClose: 'ยกเลิกการชำระเงิน',
		orderListPay: 'ไปชำระเงิน',
		loadMore: 'ดูเพิ่มเติม',
		orderTab1: 'ทั้งหมด',
		orderTab2: 'ยังไม่ชำระเงิน',
		orderTab3: 'ชำระเงินแล้ว',
		orderTab4: 'ยกเลิกแล้ว',
		orderTab5: 'คำสั่งซื้อถูกยกเลิก',
		navHome: 'หน้าแรก',
		navMyOrder: 'คำสั่งซื้อของฉัน',
		exchangeCoupon: 'ใส่โค้ดส่วนลด',
		exchangeTip: 'กรุณากรอกโค้ด',
		exchangeCode: 'โค้ด:',
		exchangeCodeTip: 'กรอกโค้ด (ตัวพิมพ์ใหญ่/ตัวเลข 16 หลัก)',
		exchange: 'แลก',
		hasCoupon: 'ยินดีด้วย! คุณได้รับโค้ดส่วนลด',
		checkExchangeCoupon: 'ดู/แลกโค้ดส่วนลด',
		share: 'สะสมได้',
		payTitle: 'ยืนยันคำสั่งซื้อ',
		isFirst: 'รางวัลการฝากเงินครั้งแรก',
		isFirst_th: 'โบนัสเติมเงินครั้งแรก',
	},
	payRule: {
		title: 'คำแนะนำการเติมเงิน',
		text1: '1. กรุณาตรวจสอบข้อมูลโดยละเอียดก่อนทำการชำระเงิน เมื่อทำรายการสำเร็จแล้ว จะไม่สามารถคืนเงินหรือย้ายไอเทม (อิริธิสต์ และอื่น ๆ) ไปยังบัญชีอื่นได้',
		text2: '2. โบนัสเติมเงินครั้งแรกทั้งบนเว็บไซต์และในเกมจะใช้ร่วมกัน ดังนั้นคุณจะได้รับโบนัสสูงสุดแค่ 1 ครั้งต่อแพ็กเกจที่ร่วมรายการ',
		text3: '3. หลังจากที่ทำการซื้อแล้ว ไอเทมจะเข้าบัญชีของคุณภายใน 5 - 60 นาที หากมีโปรโมชันที่จำกัดเวลา กรุณาทำรายการให้เสร็จก่อนเวลาสิ้นสุดโปรโมชันอย่างน้อย 1 ชั่วโมง เพื่อหลีกเลี่ยงการคำนวณยอดข้ามวัน หากคุณมีคำถามหรือต้องการความช่วยเหลือ กรุณาติดต่อฝ่ายบริการลูกค้าของเราที่ catfantasy.cs@bonfiregathering.com',
		text4: '',
		text5: '',
		text6: '',
	},
	final: {
		success: 'ทำรายการสำเร็จ',
		failed: 'การทำรายการล้มเหลว',
		goBack: 'กลับหน้าแรก',
		tips: 'รางวัลถูกส่งแล้ว กรุณารับในกล่องจดหมายในเกม',
	},
	rule: {
		title: 'ข้อควรระวัง',
		text1: '1. กรุณาตรวจสอบข้อมูลโดยละเอียดก่อนทำการชำระเงิน เมื่อทำรายการสำเร็จแล้ว จะไม่สามารถคืนเงินหรือย้ายไอเทม (อิริธิสต์ และอื่น ๆ) ไปยังบัญชีอื่นได้',
		text2: '2. โบนัสเติมเงินครั้งแรกทั้งบนเว็บไซต์และในเกมจะใช้ร่วมกัน ดังนั้นคุณจะได้รับโบนัสสูงสุดแค่ 1 ครั้งต่อแพ็กเกจที่ร่วมรายการ',
		text3: '3. หลังจากที่ทำการซื้อแล้ว ไอเทมจะเข้าบัญชีของคุณภายใน 5 - 60 นาที หากมีโปรโมชันที่จำกัดเวลา กรุณาทำรายการให้เสร็จก่อนเวลาสิ้นสุดโปรโมชันอย่างน้อย 1 ชั่วโมง เพื่อหลีกเลี่ยงการคำนวณยอดข้ามวัน หากคุณมีคำถามหรือต้องการความช่วยเหลือ กรุณาติดต่อฝ่ายบริการลูกค้าของเราที่ catfantasy.cs@bonfiregathering.com',
		text4: '4.目前港澳地区仅开放使用MyCard、Gash两种充值卡。',
		text5: '5.可充值的点数卡面额，请以官方在平台上公布的面额为主，若平台上无此面额，将无法充值成功，官方也无法进行退款哦！',
		text6: '6.目前GASH+实体礼物卡、GASH电子钱包、MyCard电子钱包等不适用于此平台充值，请您特别留意，若购买错误导致无法充值，官方将无法受理，要麻烦您向GASH或MyCard办理后续作业。',
	},
	pay: {
		title: 'ยืนยันคำสั่งซื้อ',
	},
	uidText: {
		tx1: 'กรุณากรอก ID เกมเพื่อยืนยัน',
		tx2: 'เข้าสู่ระบบ',
		tx3: 'ผูกบัญชีในเกมเพื่อรับสิทธิประโยชน์!',
		tx4: 'กรุณาเข้าสู่ระบบก่อน',
	},
};
